document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('order-samples-form');
  const addButton = document.querySelector('.order-samples-drawer__footer .button');
  const drawer = document.getElementById('samples-drawer');
  if (!form || !addButton) return;

  function updateButtonState() {
    const selectedVariants = form.querySelectorAll('input[name="selected-variants"]:checked');
    const selectedCount = selectedVariants.length;

    if (selectedCount >= 1) {
      addButton.disabled = false;
      addButton.classList.remove('disabled');
      if (selectedCount === 1) {
        addButton.textContent = 'Add sample to cart';
      } else {
        addButton.textContent = `Add ${selectedCount} samples to cart`;
      }
    } else {
      addButton.disabled = true;
      addButton.classList.add('disabled');
      addButton.textContent = 'Add samples to cart';
    }
  }

  function sendSamplesToDataLayer(selectedVariants) {
    if (typeof window.customHandleAddSamplesToCart === 'function') {
      window.customHandleAddSamplesToCart(selectedVariants);
    } else {
    }
  }

  function clearSelections() {
    const checkboxes = form.querySelectorAll('input[name="selected-variants"]:checked');
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
    });
    updateButtonState();
  }

  form.addEventListener('change', updateButtonState);
  updateButtonState();

  addButton.addEventListener('click', async function (e) {
    e.preventDefault();
    if (addButton.disabled) return;
    addButton.disabled = true;

    const selectedVariants = Array.from(form.querySelectorAll('input[name="selected-variants"]:checked'))
      .map(checkbox => checkbox.value);

    if (selectedVariants.length === 0) {
      addButton.disabled = false;
      return;
    }

    const items = selectedVariants.map(variantId => ({ id: parseInt(variantId, 10), quantity: 1 }));
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('Error adding samples to cart');
      sendSamplesToDataLayer(selectedVariants);
      clearSelections();

      if (typeof _forceCartRefreshOnAtC === 'function') _forceCartRefreshOnAtC();
      if (drawer) drawer.hide();
    } catch (err) {
      addButton.disabled = false;
    }
  });
});
